import {
	getRouteApi,
	useNavigate,
	type RegisteredRouter,
	type RouteIds,
} from '@tanstack/react-router'

export const cleanEmptyParams = <T extends Record<string, unknown>>(
	search: T
) => {
	const newSearch = { ...search }
	Object.keys(newSearch).forEach((key) => {
		const value = newSearch[key]
		if (
			value === undefined ||
			value === '' ||
			(typeof value === 'number' && isNaN(value))
		)
			delete newSearch[key]
	})

	return newSearch
}

export function useFilters<T extends RouteIds<RegisteredRouter['routeTree']>>(
	routeId: T
) {
	const routeApi = getRouteApi<T>(routeId)
	const navigate = useNavigate()
	const filters = routeApi.useSearch()

	const setFilters = (partialFilters: Partial<typeof filters>) =>
		navigate({
			// @ts-expect-error
			search: (prev) => cleanEmptyParams({ ...prev, ...partialFilters }),
		})
	// @ts-expect-error
	const resetFilters = () => navigate({ search: {} })

	return { filters, setFilters, resetFilters }
}
